import { render, staticRenderFns } from "./SaveVisitor.vue?vue&type=template&id=6e8c970b&scoped=true&"
import script from "./SaveVisitor.vue?vue&type=script&lang=tsx&"
export * from "./SaveVisitor.vue?vue&type=script&lang=tsx&"
import style0 from "./SaveVisitor.vue?vue&type=style&index=0&id=6e8c970b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c970b",
  null
  
)

export default component.exports